import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "deleteBrushIcon",
  "use": "deleteBrushIcon-usage",
  "viewBox": "0 0 9 9",
  "content": "<symbol viewBox=\"0 0 9 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"deleteBrushIcon\">\r\n    <circle cx=\"4.60914\" cy=\"4.261\" r=\"3.84352\" fill=\"#8D8D8D\" />\r\n    <path d=\"M5.64497 5.41406L3.45561 3.10795M3.57236 5.41406L5.76172 3.10795\" stroke=\"white\" stroke-width=\"0.683292\" stroke-linecap=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol